export const todayGroupHeader = "_Qd";
export const yesterdayGroupHeader = "$Qd";
export const thisWeekGroupHeader = "aRd";
export const lastWeekGroupHeader = "bRd";
export const thisMonthGroupHeader = "cRd";
export const lastMonthGroupHeader = "dRd";
export const olderGroupHeader = "eRd";
export default {todayGroupHeader,yesterdayGroupHeader,thisWeekGroupHeader,lastWeekGroupHeader,thisMonthGroupHeader,lastMonthGroupHeader,olderGroupHeader};